// extracted by mini-css-extract-plugin
export var container = "_a7-0";
export var error = "_a7-9";
export var label = "_a7-5";
export var light = "_a7-6";
export var md = "_a7-3";
export var sm = "_a7-2";
export var thin = "_a7-8";
export var thinBold = "_a7-7";
export var vertical = "_a7-4";
export var xs = "_a7-1";